webpackJsonp([13994203391546835000],{

/***/ "./src/components/fullscreen/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__("./src/components/fullscreen/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fullscreen = function Fullscreen(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      firstItem = _ref.firstItem;
	
	  var containerClassName = (0, _classnames2.default)(firstItem ? _stylesModule2.default.first : _stylesModule2.default.fullscreen, className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: containerClassName },
	    children
	  );
	};
	
	exports.default = Fullscreen;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/fullscreen/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	exports.i(__webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/css/variables.css"), "");
	
	// module
	exports.push([module.id, "._1zd9L-0DCb44zrq8fNFxmy{width:100vw;height:100vh;max-width:100%;display:flex;align-items:center;justify-content:center}._1NMJC8-tzkpFLPSIqt-zaO{margin-top:calc(var(--headerHeight) * -1)}", ""]);
	
	// exports
	exports.locals = {
		"fullscreen": "_1zd9L-0DCb44zrq8fNFxmy",
		"first": "_1NMJC8-tzkpFLPSIqt-zaO _1zd9L-0DCb44zrq8fNFxmy"
	};

/***/ }),

/***/ "./src/components/fullscreen/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/fullscreen/styles.module.css");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("./node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../node_modules/postcss-loader/index.js!./styles.module.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../node_modules/postcss-loader/index.js!./styles.module.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/shoaib/code/decision-labs.com/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-env/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/shoaib/code/decision-labs.com/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _outboundLink = __webpack_require__("./src/components/outbound-link/index.jsx");
	
	var _outboundLink2 = _interopRequireDefault(_outboundLink);
	
	var _fullscreen = __webpack_require__("./src/components/fullscreen/index.jsx");
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _meta = __webpack_require__("./src/components/meta/index.jsx");
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _wrapper = __webpack_require__("./src/components/wrapper/index.jsx");
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _stylesModule = __webpack_require__("./src/pages/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_meta2.default, { location: location }),
	    _react2.default.createElement(
	      _fullscreen2.default,
	      { className: _stylesModule2.default.intro, firstItem: true },
	      _react2.default.createElement(
	        _wrapper2.default,
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Decision Labs Consulting"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Digital Transformation, Advance Analytics, Data Science, Decision Science"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")();
	// imports
	exports.i(__webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/css/variables.css"), "");
	
	// module
	exports.push([module.id, "._2Dr5PkJBPXa7DGWtACVIDO{background:var(--colorBlack);color:var(--colorWhite)}._2Dr5PkJBPXa7DGWtACVIDO h1{font-size:2.75rem}._3nvcj0QizdESZG5Vdf38mv{border-bottom:3px solid var(--colorWhite)}@media (--small){._2Dr5PkJBPXa7DGWtACVIDO h1{font-size:1.7142rem}._3nvcj0QizdESZG5Vdf38mv{border-width:2px}}", ""]);
	
	// exports
	exports.locals = {
		"intro": "_2Dr5PkJBPXa7DGWtACVIDO",
		"link": "_3nvcj0QizdESZG5Vdf38mv"
	};

/***/ }),

/***/ "./src/pages/styles.module.css":
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/pages/styles.module.css");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("./node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../node_modules/postcss-loader/index.js!./styles.module.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../node_modules/postcss-loader/index.js!./styles.module.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-ebfe0d230eb9c5ebfb20.js